import Parse from "parse";

import type { _User } from "./_User";
import type { SIV_GoodsReceiptProcessPosition } from "./SIV_GoodsReceiptProcessPosition";
import type { SIV_Package } from "./SIV_Package";
import type { OD3_Tenant } from "./OD3_Tenant";

export interface SIV_PackageItemAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  changedAt?: Date | undefined;
  changedBy?: _User | undefined;
  goodsReceiptProcessPosition?: SIV_GoodsReceiptProcessPosition | undefined;
  notFoundValues: any;
  package: SIV_Package;
  packedQuantity?: number | undefined;
  packedWeight?: number | undefined;
  tenant?: OD3_Tenant | undefined;
}

export class SIV_PackageItem extends Parse.Object<SIV_PackageItemAttributes> {
  static className: string = "SIV_PackageItem";

  constructor(data?: Partial<SIV_PackageItemAttributes>) {
    super("SIV_PackageItem", data as SIV_PackageItemAttributes);
  }

  get changedAt(): Date | undefined {
    return super.get("changedAt");
  }
  set changedAt(value: Date | undefined) {
    super.set("changedAt", value);
  }

  get changedBy(): _User | undefined {
    return super.get("changedBy");
  }
  set changedBy(value: _User | undefined) {
    super.set("changedBy", value);
  }

  get goodsReceiptProcessPosition():
    | SIV_GoodsReceiptProcessPosition
    | undefined {
    return super.get("goodsReceiptProcessPosition");
  }
  set goodsReceiptProcessPosition(
    value: SIV_GoodsReceiptProcessPosition | undefined,
  ) {
    super.set("goodsReceiptProcessPosition", value);
  }

  get notFoundValues(): any {
    return super.get("notFoundValues");
  }
  set notFoundValues(value: any) {
    super.set("notFoundValues", value);
  }

  get package(): SIV_Package {
    return super.get("package");
  }
  set package(value: SIV_Package) {
    super.set("package", value);
  }

  get packedQuantity(): number | undefined {
    return super.get("packedQuantity");
  }
  set packedQuantity(value: number | undefined) {
    super.set("packedQuantity", value);
  }

  get packedWeight(): number | undefined {
    return super.get("packedWeight");
  }
  set packedWeight(value: number | undefined) {
    super.set("packedWeight", value);
  }

  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
}

Parse.Object.registerSubclass("SIV_PackageItem", SIV_PackageItem);
